var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1241,
    height: 1205,
    viewBox: "0 0 1241 1205",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1241 602.5C1241 935.231 963.171 1205 620.5 1205C277.829 1205 0 935.231 0 602.5C0 269.769 277.829 0 620.5 0C963.171 0 1241 269.769 1241 602.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M949.153 319L527.772 728.515L353.816 560.139L266 645.382L527.896 899L1037 404.243L949.153 319Z",
    fill: "#31C07E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/checkIcon.0be25f20a6fd55d5e4a4c40679e1ba40.svg";
export { ForwardRef as ReactComponent };